import { render, staticRenderFns } from "./PeriodWithIndexColumnTemplate.vue?vue&type=template&id=21cf3677"
import script from "./PeriodWithIndexColumnTemplate.vue?vue&type=script&lang=js"
export * from "./PeriodWithIndexColumnTemplate.vue?vue&type=script&lang=js"
import style0 from "./PeriodWithIndexColumnTemplate.vue?vue&type=style&index=0&id=21cf3677&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports